export default __webpack_public_path__ + "static/PDF_tag_Structure_Visual-018460a17c37ccc8658edfea10a01867.png";